<template>
    <div :class="classNames">
        <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" class="demo-ruleForm">
            <el-form-item label="关联课程" prop="product_id">
                <div :class="classNames + '_from_item_con'">
                    <div :class="classNames + '_add_class'">
                        <el-button type="primary" @click="showSelectClassPop = true"> {{ formData.product_id ? '更换课程' : '添加课程' }} </el-button>
                        <span style="color:#606266;font-size: 13px;margin-left: 10px;">提示：一个课程只能关联一个讲解卡</span>
                    </div>
                    <div :class="classNames + '_add_con'" v-if="formData.product_id">
                        <p :class="classNames + '_tit'">已关联课程</p>
                        <div :class="classNames + '_add_class_info'">
                            <div :class="classNames + '_add_class_left'">
                                <img :src="formData.my_class_pic" alt="" />
                            </div>
                            <div :class="classNames + '_add_class_center'">{{ formData.my_class_name }}</div>
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="讲解卡" prop="cover">
                <div :class="classNames + '_from_item_con'">
                    <el-button type="primary" @click="uploadFn">
                         {{ formData.cover ? '替换图片' : '上传图片' }}
                        <el-tooltip placement="top">
                            <div slot="content">
                                支持上传类型：{{ acceptArr.join('、') }}
                            </div>
                            <span><i class="el-icon-question" style="cursor: pointer;"></i></span>
                        </el-tooltip>
                    </el-button>
                    <span style="color:#606266;font-size: 13px;margin-left: 10px;">提示：卡片尺寸比例1:1，最大不超过2MB</span>
                    <div>
                        <el-image 
                            v-if="formData.cover"
                            fit="cover"
                            style="width: 100px; height: 100px; margin-top: 10px;"
                            :src="formData.cover" 
                            :preview-src-list="[formData.cover]">
                        </el-image>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="锚点标题" prop="anchor_title">
                <div :class="classNames + '_from_item_con'">
                    <el-input v-model="formData.anchor_title" placeholder="限制20字以内" style="width: 300px;" maxlength="20"></el-input>                    
                </div>
            </el-form-item>
            <div class="btns-box">
                <el-button @click="backFn">返回</el-button>
                <el-button style="margin-left: 80px;" type="primary" @click="submitFn">保存</el-button>
            </div>
        </el-form>
        <selectClassPop v-model="showSelectClassPop" @sure="selectClassSure"></selectClassPop>
        <uploadImgPop v-model="showUploadImgPop" @uploadSuccess="uploadSuccess" :accept="acceptArr" :maxSize="2"></uploadImgPop>
    </div>
</template>

<script>
import selectClassPop from './components/selectClassPop.vue'
import uploadImgPop from './components/uploadImgPop.vue'
import { throttle } from 'lodash-unified'
import { mapActions } from 'vuex'
export default {
    components: {
        selectClassPop,
        uploadImgPop
    },
    data() {
        return {
            classNames: "addExplainCard",
            cardId: null, // 当前讲解卡id
            formData: {
                product_id: '',// 课程id
                my_class_pic: '',
                my_class_name: '',
                cover: '', // 讲解卡图片
                anchor_title: '' // 锚点标题
            },
            acceptArr: ['.jpg','.png','.jpeg'],
            rules: {
                product_id: [
                    {
                        required: true,
                        message: "请添加课程",
                        trigger: "none",
                    },
                ],
                cover: [
                    {
                        required: true,
                        message: "请上传讲解卡图片",
                        trigger: "none",
                    },
                ],
            },
            showSelectClassPop: false, // 展示选择课程弹窗
            showUploadImgPop: false // 展示上传弹窗
        }
    },
    created(){
        this.initData()
    },
    methods: {
        ...mapActions('explainCard',['addEditDelExplainCardAPI', 'getForCardClassListAPI']),
        initData(){
            console.log('this.$route.query:',this.$route.query)
            // id=讲解卡id, cid=课程id, title=讲解卡锚点标题, ctitle=课程标题, pic=讲解卡图片, cpic=课程图片
            let { id, cid, title, ctitle, pic, cpic } = this.$route.query
            this.cardId = id || null
            if(this.cardId){
                this.formData.product_id = decodeURIComponent(cid) || ''
                this.formData.my_class_pic = decodeURIComponent(cpic)  || ''
                this.formData.my_class_name = decodeURIComponent(ctitle)  || ''
                this.formData.cover = decodeURIComponent(pic)  || ''
                this.formData.anchor_title = decodeURIComponent(title)  || ''
            }
        },
        backFn(){
            this.$router.back()
        },
        selectClassSure(e) {
            console.log('selectClassSure-e:', e)
            this.formData.product_id = e.id
            this.formData.my_class_pic = e.img
            this.formData.my_class_name = e.title
        },
        // 点击上传
        uploadFn(){ 
            this.showUploadImgPop=true
        },
        // 上传成功
        uploadSuccess(e){
            // console.log('uploadSuccess-e:',e)
            this.formData.cover = e.url
        },
        submitFn:throttle(function(){
            let that = this
            this.$refs.formRef.validate(async valid=>{
                if(valid){
                    console.log('校验通过')
                    let params = {...this.formData}
                    delete params.my_class_name
                    delete params.my_class_pic
                    if(this.cardId){ // 有则是编辑
                        params.id = this.cardId
                    }
                    await that.addEditDelExplainCardAPI(params)
                    this.$message({
                        message: '保存成功',
                        type: "success",
                        duration: 3000
                    })
                    this.$router.replace({
                        path: this.staticPath + 'explainCard'
                    })
                }
            })
        },1000),
        
    }
}
</script>

<style lang="less" scoped>
@classNames: addExplainCard;
.@{classNames} {
    max-width: 660px;

    .@{classNames}_from_item_con {
        width: 660px;
        display: inline-block;
        position: relative;
    }
}
.@{classNames}_add_con {
    margin-top: 10px;
    width: 400px;
    background: #f8f9fb;
    padding: 10px;
    .@{classNames}_tit {
        font-size: 14px;
        color: #37383c;
        line-height: 20px;
        font-weight: 550;
    }
    .@{classNames}_add_class_info {
        height: 80px;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        align-items: center;
        .@{classNames}_add_class_left {
            width: 60px;
            height: 45px;

            img {
                width: 100%;
                height: 100%;
            }
        }
        .@{classNames}_add_class_center {
            margin-left: 30px;
            color: #6a6c76;
            word-break: break-all;
            line-height: normal;
        }
    }
}
.btns-box{
    display: flex;
    justify-content: center;
}
</style>